import { useEffect } from 'react'

export function useSyncScroll(refs = []) {
  useEffect(() => {
    const elements = refs.map(ref => ref?.current).filter(Boolean)

    if (elements.length < 2) {
      return undefined
    }

    let isSyncing = false

    const onScroll = event => {
      if (isSyncing) {
        return
      }

      isSyncing = true
      const scrollLeft = event.target.scrollLeft

      elements.forEach(element => {
        if (element !== event.target && element.scrollLeft !== scrollLeft) {
          element.scrollLeft = scrollLeft
        }
      })

      isSyncing = false
    }

    elements.forEach(element => {
      element.addEventListener('scroll', onScroll, { passive: true })
    })

    return () => {
      elements.forEach(element => {
        element.removeEventListener('scroll', onScroll)
      })
    }
  }, [refs])
}
